import {
  Space,
  Dropdown,
  message,
  Flex,
  Tooltip,
  Tag
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  EditOutlined,
  MenuOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import EmploymentTitleModal from "./component/EmploymentTitleModal";
import { CustomTable, CustomTableExtend, CustomModal } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {

  const [currentRecord, setCurrentRecord] = useState(null);

  const initColumns = [
    // {
    //   dataIndex: '#'
    // },
    {
      title: "Action",
      key: "action",
      dataIndex: "",
      hidden: false,
      align: "center",
      width: 80,
      render: (text, record, index) => (
        (commonFn.btnAuthorityFlag("Edit") || commonFn.btnAuthorityFlag("Delete")) && (<Dropdown
          menu={{
            items: [
              commonFn.btnAuthorityFlag("Edit") && {
                key: "edit",
                icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Edit</div>,
              },
              commonFn.btnAuthorityFlag("Delete") && {
                key: "delete",
                icon: <HistoryOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Delete</div>,
              },
            ],
            onClick: (e) => handleMenuClick(e, record),
          }} 
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>
        )) || null
    },
    {
      title: 'Employment Title',
      dataIndex: "titleName",
      titleType: '',
    },
    {
      title: 'Code',
      dataIndex: "titleCode",
      titleType: '',
    },
    {
      title: 'System Role',
      dataIndex: "roleNames",
      titleType: '',
      render: (roleList) => {
        if (!(roleList || [])?.length) {
          return "";
        }
        return (
          <Flex gap="4px 0" wrap="wrap" align="center" justify='center'>
            {roleList.map((item, idx) => (
              <Tooltip key={idx} title={item}>
                <Tag
                  color="rgba(110,140,81,0.12)"
                  style={{
                    fontSize: 14,
                    backgroundColor: 'rgba(110,140,81,0.12)',
                    color: '#000',
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item}
                </Tag>
              </Tooltip>
            ))}
          </Flex>
        );
      },
    },
    {
      title: 'Sort Order',
      dataIndex: "sortOrder",
      titleType: '',
    },
    {
      title: 'Status',
      dataIndex: "status",
      titleType: '',
      // isSorter: true,
      sortterMultiple: 3,
      render: (text) => {
        const isEnabled = text == 1;
        return (
          <Tag
            color={isEnabled ? "green" : "red"}
          >
            { isEnabled ? "Active" : "Inactive" }
          </Tag>
        )
      },
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);

  //列表
  const getTableListFn = async () => {
    setTableLoading(true);
    const params = {};
    const response = await http.get(api.employmentTitleList, { params });
    if(!response) return
    if(response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    setTableList(response.data);
    setTableLoading(false);
  };

  // 新增修改
  const EmploymentTitleRef = useRef(null);
  
  const newFn = () => {
    EmploymentTitleRef.current.openModal({
      type: 'add',
      modalName: 'New Employment Title',
    })
  }

  const customModalRef = useRef(null);

  const handleMenuClick = async (item, record) => {
    const { key } = item
    setCurrentRecord(record);
    if(['edit'].includes(key)){
      EmploymentTitleRef.current.openModal({
        oldState: record,
        type: 'edit',
        modalName: 'Edit Employment Title',
      })
    }else if(['delete'].includes(key)) {
      customModalRef.current.openModalFn();
    }
  }

  const deleteFn = async () => {
    const response = await http.get(api.employmentTitleDelete, {
      params: {
        id: currentRecord.id
      },
    });
    if (response.code === "1") {
      message.success("Successfully delete.");
      getTableListFn();
    } else {
      commonFn.modalFailedFn(response);
    }
  };

  const initColunmsFn = () => {
    setTableList([])
    setColumns(initColumns);
  }

  const submitInitFn = () => {
    initColunmsFn()
    getTableListFn();
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn()
  }, [refreshKey])

  useEffect(() => {

  }, [])

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
        <div className="topLeft">
          {(commonFn.btnAuthorityFlag("New") && (
            <Space size="large">
                {commonFn.btnDocFn({ btnFn: newFn },{
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
           )) || null}
        </div>
      </CustomTableExtend>

      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowKey="id"
        columns={columns}
        tableList={tableList}
        pagination={false}
        tableScrollY="350px"
      />

      <EmploymentTitleModal
        ref={EmploymentTitleRef}
        submitInitFn={submitInitFn}
      />

      <CustomModal
        ref={customModalRef}
        customConfig={{
          width: 500,
          deleteContent: "holiday calendar",
          onOkFn: deleteFn,
        }}
      />
    </div>
  );
});
export default MainTable;
